import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var position_center_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M19 5.5H5V4h14v1.5ZM19 20H5v-1.5h14V20ZM7 9h10v6H7V9Z" }) });
export {
  position_center_default as default
};
//# sourceMappingURL=position-center.js.map
